import React from 'react';
import PropTypes from 'prop-types';
import { StyledCtaShell } from './styles.js';

/**
 * Layout shell for CTAs nested in page sections.
 * Owns stretch-to-parent when full-width flags are set, and packs the CTA
 * left/center/right when CMS `alignment` is provided.
 */
export const CtaShell = ({
  children,
  fullWidth = false,
  fullWidthMobile = false,
  fullWidthDesktop = false,
  sideMargin,
  defaultWidth,
  alignment,
  className,
  ...rest
}) => (
  <StyledCtaShell
    className={className}
    $fullWidth={fullWidth}
    $fullWidthMobile={fullWidthMobile}
    $fullWidthDesktop={fullWidthDesktop}
    $sideMargin={sideMargin}
    $defaultWidth={defaultWidth}
    $alignment={alignment}
    {...rest}
  >
    {children}
  </StyledCtaShell>
);

CtaShell.displayName = 'CtaShell';

CtaShell.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  fullWidthMobile: PropTypes.bool,
  fullWidthDesktop: PropTypes.bool,
  sideMargin: PropTypes.bool,
  defaultWidth: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
  className: PropTypes.string,
};
